import {
  BASE_TELEMETRY_PROPERTIES,
  __export,
  getTelemetryIdentifier,
  setupTelemetryListeners
} from "./chunk-GBLFVQ25.mjs";

// packages/apps/patterns/react-appkit/src/components/AuthChoices/AuthChoices.tsx
import { CaretRight, Plus, QrCode, Textbox } from "@phosphor-icons/react";
import React from "react";
import { CompoundButton, useTranslation } from "@dxos/react-components";
var AuthChoices = ({ onCreate, onJoin, onRecover }) => {
  const { t } = useTranslation("appkit");
  return /* @__PURE__ */ React.createElement("div", {
    role: "none",
    className: "flex flex-col gap-2 mt-4 px-2"
  }, onCreate && /* @__PURE__ */ React.createElement(CompoundButton, {
    description: t("create identity description"),
    before: /* @__PURE__ */ React.createElement(Plus, {
      className: "w-6 h-6"
    }),
    after: /* @__PURE__ */ React.createElement(CaretRight, {
      className: "w-4 h-4",
      weight: "bold"
    }),
    className: "text-lg w-full",
    onClick: onCreate,
    "data-testid": "create-identity-button"
  }, t("create identity label")), onJoin && /* @__PURE__ */ React.createElement(CompoundButton, {
    description: t("join identity description"),
    before: /* @__PURE__ */ React.createElement(QrCode, {
      className: "w-6 h-6"
    }),
    after: /* @__PURE__ */ React.createElement(CaretRight, {
      className: "w-4 h-4",
      weight: "bold"
    }),
    className: "text-lg w-full",
    onClick: onJoin,
    "data-testid": "join-identity-button"
  }, t("join identity label")), onRecover && /* @__PURE__ */ React.createElement(CompoundButton, {
    // TODO(mykola): Implement recover.
    disabled: true,
    description: t("recover identity description"),
    before: /* @__PURE__ */ React.createElement(Textbox, {
      className: "w-6 h-6"
    }),
    after: /* @__PURE__ */ React.createElement(CaretRight, {
      className: "w-4 h-4",
      weight: "bold"
    }),
    className: "text-lg w-full",
    onClick: onRecover,
    "data-testid": "recover-identity-button"
  }, t("recover identity label")));
};

// packages/apps/patterns/react-appkit/src/components/DeviceList/DeviceList.tsx
import React3 from "react";
import { DeviceKind } from "@dxos/protocols/proto/dxos/client/services";

// packages/apps/patterns/react-appkit/src/components/DeviceList/Device.tsx
import React2 from "react";
import { Avatar, Group, Tag, useTranslation as useTranslation2 } from "@dxos/react-components";
var Device = (props) => {
  const { t } = useTranslation2("appkit");
  return /* @__PURE__ */ React2.createElement(Group, {
    label: {
      level: 2,
      className: "mb-0 text-lg font-body flex gap-2 items-center",
      children: /* @__PURE__ */ React2.createElement(Avatar, {
        size: 10,
        fallbackValue: props.publicKey.toHex(),
        label: /* @__PURE__ */ React2.createElement("p", null, props.displayName, props.isCurrentDevice && /* @__PURE__ */ React2.createElement(Tag, {
          valence: "info",
          className: "mli-2 align-middle"
        }, t("current device label")))
      })
    },
    className: "mbe-2"
  });
};

// packages/apps/patterns/react-appkit/src/components/DeviceList/DeviceList.tsx
var DeviceList = ({ devices }) => {
  return /* @__PURE__ */ React3.createElement(React3.Fragment, null, devices.map((device, index) => /* @__PURE__ */ React3.createElement(Device, {
    key: device.deviceKey.toHex(),
    publicKey: device.deviceKey,
    isCurrentDevice: device.kind === DeviceKind.CURRENT
  })));
};

// packages/apps/patterns/react-appkit/src/components/EditableList/EditableList.tsx
import { X, Plus as Plus2 } from "@phosphor-icons/react";
import React5, { forwardRef, useCallback } from "react";
import { List, ListItem, ListItemHeading, Input, ListItemEndcap, ListItemDragHandle, mx as mx2, Button, getSize, useTranslation as useTranslation3, defaultDescription, useListDensity, DensityProvider } from "@dxos/react-components";

// packages/apps/patterns/react-appkit/src/components/Tooltip/Tooltip.tsx
import { Root as PortalRoot } from "@radix-ui/react-portal";
import { Button as ToolbarButtonItem } from "@radix-ui/react-toolbar";
import { Portal as TooltipPortal } from "@radix-ui/react-tooltip";
import React4, { useState } from "react";
import { TooltipContent, TooltipTrigger, TooltipRoot, defaultTooltip, mx, useId } from "@dxos/react-components";
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Tooltip = ({ content, children, side, compact, tooltipLabelsTrigger, mountAsSibling, triggerIsInToolbar, zIndex = "z-[2]", slots = {} }) => {
  var _a, _b, _c;
  const [isOpen, setIsOpen] = useState(false);
  const labelId = useId("tooltipLabel");
  const tooltipContent = /* @__PURE__ */ React4.createElement(TooltipContent, _extends({
    forceMount: true
  }, slots.content, {
    side: (_b = side != null ? side : (_a = slots.content) == null ? void 0 : _a.side) != null ? _b : "top",
    className: mx(zIndex, !compact && "px-4 py-2.5", !isOpen && "sr-only", defaultTooltip, (_c = slots.content) == null ? void 0 : _c.className)
  }), content);
  const triggerContent = /* @__PURE__ */ React4.createElement(TooltipTrigger, _extends({
    asChild: true
  }, tooltipLabelsTrigger && {
    "aria-labelledby": labelId
  }), children);
  return /* @__PURE__ */ React4.createElement(TooltipRoot, {
    open: isOpen,
    onOpenChange: setIsOpen
  }, triggerIsInToolbar ? /* @__PURE__ */ React4.createElement(ToolbarButtonItem, {
    asChild: true
  }, triggerContent) : triggerContent, tooltipLabelsTrigger && /* @__PURE__ */ React4.createElement(PortalRoot, {
    asChild: true
  }, /* @__PURE__ */ React4.createElement("span", {
    id: labelId,
    className: "sr-only"
  }, content)), mountAsSibling ? tooltipContent : /* @__PURE__ */ React4.createElement(TooltipPortal, _extends({
    forceMount: true
  }, zIndex && {
    className: `!${zIndex}`
  }), tooltipContent));
};

// packages/apps/patterns/react-appkit/src/components/EditableList/EditableList.tsx
function _extends2() {
  _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
var focusAndSetCaretPosition = (prevEl, nextEl) => {
  var _a;
  const pos = (_a = prevEl.selectionStart) != null ? _a : 0;
  if ("selectionStart" in nextEl) {
    nextEl.focus();
    nextEl.setSelectionRange(pos, pos);
  } else {
    nextEl.focus();
  }
};
var useEditableListKeyboardInteractions = (hostId) => {
  const hostAttrs = {
    "data-focus-series-host": hostId
  };
  const itemAttrs = {
    "data-focus-series": "editableList"
  };
  const onListItemInputKeyDown = useCallback((event2) => {
    const inputsInScope = Array.from(document.querySelectorAll(`[data-focus-series-host="${hostId}"] [data-focus-series="editableList"]`));
    const targetIndex = inputsInScope.findIndex((sibling) => sibling === event2.target);
    switch (event2.key) {
      case "Enter":
      case "PageDown": {
        if (targetIndex < inputsInScope.length - 1) {
          event2.preventDefault();
          focusAndSetCaretPosition(event2.target, inputsInScope[targetIndex + 1]);
        }
        break;
      }
      case "PageUp": {
        if (targetIndex > 0) {
          event2.preventDefault();
          focusAndSetCaretPosition(event2.target, inputsInScope[targetIndex - 1]);
        }
        break;
      }
    }
  }, [
    hostId
  ]);
  return {
    onListItemInputKeyDown,
    hostAttrs,
    itemAttrs
  };
};
var EditableList = ({ children, labelId, completable, variant = "ordered-draggable", onClickAdd, nextItemTitle, defaultNextItemTitle, onChangeNextItemTitle, itemIdOrder, onMoveItem, density: propsDensity, slots = {} }) => {
  var _a, _b, _c, _d, _e;
  const { t } = useTranslation3("appkit");
  const density = useListDensity({
    density: propsDensity,
    variant
  });
  const handleDragEnd = (event2) => {
    const { active, over } = event2;
    if (itemIdOrder && (over == null ? void 0 : over.id) && active.id !== (over == null ? void 0 : over.id)) {
      const oldIndex = itemIdOrder.findIndex((id) => id === active.id);
      const newIndex = itemIdOrder.findIndex((id) => id === over.id);
      onMoveItem == null ? void 0 : onMoveItem(oldIndex, newIndex);
    }
  };
  return /* @__PURE__ */ React5.createElement("div", _extends2({
    role: "none"
  }, slots.root, {
    className: mx2("contents", (_a = slots.root) == null ? void 0 : _a.className)
  }), /* @__PURE__ */ React5.createElement(List, {
    labelId,
    variant,
    selectable: completable,
    onDragEnd: handleDragEnd,
    listItemIds: itemIdOrder != null ? itemIdOrder : [],
    slots: slots.list,
    density
  }, children), /* @__PURE__ */ React5.createElement("div", {
    className: "flex"
  }, /* @__PURE__ */ React5.createElement(DensityProvider, {
    density
  }, /* @__PURE__ */ React5.createElement(ListItemDragHandle, {
    className: variant === "ordered-draggable" ? "invisible" : "hidden"
  }), /* @__PURE__ */ React5.createElement(ListItemEndcap, {
    className: "invisible"
  }), /* @__PURE__ */ React5.createElement(Input, _extends2({
    variant: "subdued",
    label: t("new list item input label"),
    labelVisuallyHidden: true,
    placeholder: t("new list item input placeholder")
  }, {
    value: nextItemTitle,
    defaultValue: defaultNextItemTitle,
    onChange: onChangeNextItemTitle
  }, {
    slots: {
      ...slots.addItemInput,
      root: {
        ...(_b = slots.addItemInput) == null ? void 0 : _b.root,
        className: mx2("grow", (_d = (_c = slots.addItemInput) == null ? void 0 : _c.root) == null ? void 0 : _d.className)
      }
    }
  })), /* @__PURE__ */ React5.createElement(ListItemEndcap, null, /* @__PURE__ */ React5.createElement(Tooltip, {
    content: /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement("span", {
      className: "mie-2"
    }, t("add list item label")), /* @__PURE__ */ React5.createElement("span", {
      className: defaultDescription
    }, "\u23CE")),
    side: "left",
    tooltipLabelsTrigger: true
  }, /* @__PURE__ */ React5.createElement(Button, _extends2({
    variant: "ghost"
  }, slots.addItemButton, {
    className: mx2("p-1", (_e = slots.addItemButton) == null ? void 0 : _e.className),
    onClick: onClickAdd
  }), /* @__PURE__ */ React5.createElement(Plus2, {
    className: getSize(4)
  })))))));
};
var EditableListItem = /* @__PURE__ */ forwardRef(({ id, defaultCompleted, completed, onChangeCompleted, defaultTitle, title, onChangeTitle, onClickDelete, slots = {} }, forwardedRef) => {
  var _a, _b, _c;
  const { t } = useTranslation3("appkit");
  return /* @__PURE__ */ React5.createElement(ListItem, _extends2({
    ref: forwardedRef
  }, {
    id,
    defaultSelected: defaultCompleted,
    selected: completed,
    onSelectedChange: onChangeCompleted,
    slots: slots.listItem
  }), /* @__PURE__ */ React5.createElement(ListItemHeading, {
    className: "sr-only"
  }, title), /* @__PURE__ */ React5.createElement(Input, _extends2({}, {
    variant: "subdued",
    label: t("list item input label"),
    labelVisuallyHidden: true,
    placeholder: t("list item input placeholder"),
    slots: {
      ...slots.input,
      root: {
        ...(_a = slots.input) == null ? void 0 : _a.root,
        className: mx2("grow", (_c = (_b = slots.input) == null ? void 0 : _b.root) == null ? void 0 : _c.className)
      }
    },
    value: title,
    defaultValue: defaultTitle,
    onChange: onChangeTitle
  }), title != null ? title : defaultTitle), onClickDelete && /* @__PURE__ */ React5.createElement(ListItemEndcap, null, /* @__PURE__ */ React5.createElement(Tooltip, {
    content: t("delete list item label"),
    side: "left",
    tooltipLabelsTrigger: true
  }, /* @__PURE__ */ React5.createElement(Button, {
    variant: "ghost",
    className: "p-1",
    onClick: onClickDelete
  }, /* @__PURE__ */ React5.createElement(X, {
    className: getSize(4)
  })))));
});

// packages/apps/patterns/react-appkit/src/components/ErrorProvider/ErrorProvider.tsx
import { Warning } from "@phosphor-icons/react";
import React6, { createContext, useCallback as useCallback2, useContext, useEffect, useState as useState2 } from "react";
import { valenceColorText, defaultFocus, useTranslation as useTranslation4, mx as mx3 } from "@dxos/react-components";
import { captureException } from "@dxos/sentry";
var ErrorContext = /* @__PURE__ */ createContext({
  errors: [],
  addError: () => {
  },
  resetErrors: () => {
  }
});
var logError = (f, ...args) => console.error(f, ...args);
var ErrorProvider = ({ children }) => {
  const { t } = useTranslation4("appkit");
  const [errors, setErrors] = useState2([]);
  const addError = useCallback2((error) => setErrors([
    error,
    ...errors
  ]), []);
  const resetErrors = useCallback2(() => setErrors([]), []);
  const onUnhandledRejection = useCallback2((event2) => {
    captureException(event2.reason);
    logError("unhandledrejection", event2.reason);
    addError(event2.reason);
    event2.preventDefault();
  }, []);
  const onWindowError = useCallback2((message, source, lineno, colno, error) => {
    captureException(error);
    logError("onerror", message);
    addError(error);
    return true;
  }, []);
  useEffect(() => {
    window.onerror = onWindowError;
    window.addEventListener("unhandledrejection", onUnhandledRejection);
    return () => {
      window.onerror = null;
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
    };
  }, []);
  return /* @__PURE__ */ React6.createElement(ErrorContext.Provider, {
    value: {
      errors,
      addError,
      resetErrors
    }
  }, children, /* @__PURE__ */ React6.createElement("div", {
    role: "none",
    className: mx3("fixed bottom-2 right-2", valenceColorText("warning"))
  }, !!errors.length && /* @__PURE__ */ React6.createElement(Tooltip, {
    content: t("caught error message")
  }, /* @__PURE__ */ React6.createElement(Warning, {
    tabIndex: 0,
    weight: "duotone",
    className: mx3("w-6 h-6 rounded-md", defaultFocus)
  }))));
};
var useErrors = () => useContext(ErrorContext);

// packages/apps/patterns/react-appkit/src/components/Fallback/Fallback.tsx
import React7, { useState as useState3, useCallback as useCallback3 } from "react";
import { Trigger } from "@dxos/async";
import { SystemStatus } from "@dxos/client";
import { Button as Button2, Heading, Loading, useTranslation as useTranslation5 } from "@dxos/react-components";
var Fallback = ({ message }) => {
  return /* @__PURE__ */ React7.createElement("div", {
    className: "py-8 flex flex-col gap-4",
    "aria-live": "polite"
  }, /* @__PURE__ */ React7.createElement(Loading, {
    label: message,
    size: "lg"
  }), /* @__PURE__ */ React7.createElement(Heading, {
    level: 1,
    className: "text-lg font-light text-center"
  }, message));
};
var GenericFallback = () => {
  const { t } = useTranslation5("appkit");
  return /* @__PURE__ */ React7.createElement(Fallback, {
    message: t("generic loading label", {
      ns: "appkit"
    })
  });
};
var ClientFallback = ({ client, status }) => {
  const { t } = useTranslation5("appkit");
  const [pending, setPending] = useState3(false);
  const resume = useCallback3(async () => {
    setPending(true);
    const done = new Trigger();
    setTimeout(() => done.wake(), 1e3);
    await (client == null ? void 0 : client.resumeHostServices());
    await done.wait();
    setPending(false);
  }, [
    client
  ]);
  switch (status) {
    case SystemStatus.INACTIVE:
      return /* @__PURE__ */ React7.createElement("div", {
        className: "flex flex-col gap-4 justify-center items-center h-screen",
        "aria-live": "polite"
      }, /* @__PURE__ */ React7.createElement(Heading, {
        level: 1,
        className: "text-lg font-light text-center"
      }, t("resume heading label")), /* @__PURE__ */ React7.createElement(Heading, {
        level: 3,
        className: "text-sm font-light text-center"
      }, t("resume description label")), /* @__PURE__ */ React7.createElement(Button2, {
        disabled: pending,
        onClick: resume
      }, t("resume label")));
    default:
      return /* @__PURE__ */ React7.createElement(GenericFallback, null);
  }
};

// packages/apps/patterns/react-appkit/src/components/FatalError/FatalError.tsx
import { Clipboard } from "@phosphor-icons/react";
import React8, { useCallback as useCallback4 } from "react";
import { Alert, Button as Button3, Dialog, useTranslation as useTranslation6 } from "@dxos/react-components";
var parseError = (error) => {
  const message = String(error);
  let stack = String(error == null ? void 0 : error.stack);
  if (stack.indexOf(message) === 0) {
    stack = stack.substr(message.length).trim();
  }
  stack = stack.split("\n").map((text) => text.trim()).join("\n");
  return {
    message,
    stack
  };
};
var FatalError = ({ error }) => {
  const { t } = useTranslation6("appkit");
  const isDev = true;
  const { message, stack } = parseError(error);
  const onCopyError = useCallback4(() => {
    void navigator.clipboard.writeText(JSON.stringify({
      message,
      stack
    }));
  }, [
    message,
    stack
  ]);
  return /* @__PURE__ */ React8.createElement(Dialog, {
    title: t("fatal error label"),
    slots: {
      overlay: {
        className: "md:w-[500px"
      },
      content: {
        className: "w-full]"
      }
    },
    defaultOpen: true
  }, isDev ? /* @__PURE__ */ React8.createElement(Alert, {
    title: message,
    valence: "error",
    slots: {
      root: {
        className: "mlb-4"
      }
    }
  }, /* @__PURE__ */ React8.createElement("pre", {
    className: "text-xs overflow-auto max-w-72 max-h-72 overflow-hidden"
  }, stack)) : /* @__PURE__ */ React8.createElement("p", null, t("fatal error message")), /* @__PURE__ */ React8.createElement("div", {
    role: "none",
    className: "flex"
  }, /* @__PURE__ */ React8.createElement(Tooltip, {
    content: t("copy error label"),
    zIndex: "z-[21]"
  }, /* @__PURE__ */ React8.createElement(Button3, {
    onClick: onCopyError
  }, /* @__PURE__ */ React8.createElement(Clipboard, {
    weight: "duotone",
    size: "1em"
  }))), /* @__PURE__ */ React8.createElement("div", {
    role: "none",
    className: "flex-grow"
  }), /* @__PURE__ */ React8.createElement(Button3, {
    variant: "primary",
    onClick: () => location.reload()
  }, t("reload page label"))));
};

// packages/apps/patterns/react-appkit/src/components/HeadingWithActions/HeadingWithActions.tsx
import React9 from "react";
import { Heading as Heading2, mx as mx4 } from "@dxos/react-components";
function _extends3() {
  _extends3 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
var HeadingWithActions = ({ heading, actions, compact, spacer, ...divProps }) => {
  return /* @__PURE__ */ React9.createElement("div", _extends3({
    role: "none"
  }, divProps, {
    className: mx4("flex flex-wrap items-center", compact ? "gap-2" : "gap-x-2 gap-y-4", divProps.className)
  }), /* @__PURE__ */ React9.createElement(Heading2, _extends3({}, heading)), typeof spacer === "undefined" ? /* @__PURE__ */ React9.createElement("div", {
    role: "none",
    className: "grow-[99] min-w-[1rem]"
  }) : spacer, /* @__PURE__ */ React9.createElement("div", {
    role: "none",
    className: "flex grow gap-2 items-center"
  }, actions));
};

// packages/apps/patterns/react-appkit/src/components/InvitationList/InvitationList.tsx
import React12 from "react";
import { defaultDisabled, Group as Group2, useTranslation as useTranslation9, mx as mx7 } from "@dxos/react-components";

// packages/apps/patterns/react-appkit/src/components/InvitationList/PendingInvitation.tsx
import { ProhibitInset, XCircle } from "@phosphor-icons/react";
import React11, { useCallback as useCallback5 } from "react";
import { Invitation as Invitation2 } from "@dxos/client";
import { useInvitationStatus } from "@dxos/react-client";
import { Avatar as Avatar2, Button as Button4, CompactQrCode, defaultGroup, getSize as getSize3, Loading as Loading2, useTranslation as useTranslation8, mx as mx6 } from "@dxos/react-components";

// packages/apps/patterns/react-appkit/src/components/InvitationStatus/InvitationStatus.tsx
import React10, { useMemo } from "react";
import { Invitation } from "@dxos/client";
import { strongShimmer, getSize as getSize2, mx as mx5, useTranslation as useTranslation7 } from "@dxos/react-components";
function _extends4() {
  _extends4 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends4.apply(this, arguments);
}
var pip = mx5("rounded-full flex-none", getSize2(2));
var stripe = mx5("rounded-full grow", getSize2(2));
var inactiveColor = "bg-neutral-100 dark:bg-neutral-600";
var activeColor = "bg-primary-500 dark:bg-primary-400";
var successColor = "bg-success-500 dark:bg-success-400";
var errorColor = "bg-error-500 dark:bg-error-400";
var cancelledColor = "bg-warning-500 dark:bg-warning-400";
var statusValueMap = /* @__PURE__ */ new Map([
  [
    Invitation.State.ERROR,
    -3
  ],
  [
    Invitation.State.TIMEOUT,
    -2
  ],
  [
    Invitation.State.CANCELLED,
    -1
  ],
  [
    Invitation.State.INIT,
    0
  ],
  [
    Invitation.State.CONNECTING,
    1
  ],
  [
    Invitation.State.CONNECTED,
    2
  ],
  [
    Invitation.State.AUTHENTICATING,
    3
  ],
  [
    Invitation.State.SUCCESS,
    4
  ]
]);
var InvitationStatus = ({ status, haltedAt, ...rootProps }) => {
  const { t } = useTranslation7("appkit");
  const statusLabelMap = useMemo(() => /* @__PURE__ */ new Map([
    [
      Invitation.State.ERROR,
      t("error status label")
    ],
    [
      Invitation.State.TIMEOUT,
      t("timeout status label")
    ],
    [
      Invitation.State.CANCELLED,
      t("cancelled status label")
    ],
    [
      Invitation.State.INIT,
      t("init status label")
    ],
    [
      Invitation.State.CONNECTING,
      t("connecting status label")
    ],
    [
      Invitation.State.CONNECTED,
      t("connected status label")
    ],
    [
      Invitation.State.AUTHENTICATING,
      t("authenticating status label")
    ],
    [
      Invitation.State.SUCCESS,
      t("success status label")
    ]
  ]), [
    t
  ]);
  const halted = status === Invitation.State.CANCELLED || status === Invitation.State.TIMEOUT || status === Invitation.State.ERROR;
  const cursor = statusValueMap.get(halted ? haltedAt : status);
  const resolvedColor = status === Invitation.State.ERROR ? errorColor : status === Invitation.State.CANCELLED || status === Invitation.State.TIMEOUT ? cancelledColor : successColor;
  return /* @__PURE__ */ React10.createElement("div", _extends4({
    role: "status",
    "aria-label": statusLabelMap.get(status)
  }, rootProps, {
    className: mx5("flex gap-2 items-center", rootProps.className)
  }), /* @__PURE__ */ React10.createElement("div", {
    role: "none",
    className: mx5(pip, "relative")
  }, /* @__PURE__ */ React10.createElement("div", {
    role: "none",
    className: mx5(pip, "absolute", !halted && cursor === 0 ? "animate-ping block" : "hidden", activeColor)
  }), /* @__PURE__ */ React10.createElement("div", {
    role: "none",
    className: mx5(pip, "relative", cursor === 0 ? halted ? resolvedColor : activeColor : cursor > 0 ? resolvedColor : inactiveColor)
  })), /* @__PURE__ */ React10.createElement("div", {
    role: "none",
    className: mx5(stripe, !halted && cursor === 1 && strongShimmer, cursor === 1 ? halted ? resolvedColor : activeColor : cursor > 1 ? resolvedColor : inactiveColor)
  }), /* @__PURE__ */ React10.createElement("div", {
    role: "none",
    className: mx5(pip, "relative")
  }, /* @__PURE__ */ React10.createElement("div", {
    role: "none",
    className: mx5(pip, "absolute", !halted && cursor === 2 ? "animate-ping block" : "hidden", activeColor)
  }), /* @__PURE__ */ React10.createElement("div", {
    role: "none",
    className: mx5(pip, "relative", cursor === 2 ? halted ? resolvedColor : activeColor : cursor > 2 ? resolvedColor : inactiveColor)
  })), /* @__PURE__ */ React10.createElement("div", {
    role: "none",
    className: mx5(stripe, !halted && cursor === 3 && strongShimmer, cursor === 3 ? activeColor : cursor > 3 ? halted ? resolvedColor : resolvedColor : inactiveColor)
  }), /* @__PURE__ */ React10.createElement("div", {
    role: "none",
    className: mx5(pip, cursor >= 4 ? resolvedColor : inactiveColor)
  }));
};

// packages/apps/patterns/react-appkit/src/components/InvitationList/PendingInvitation.tsx
function _extends5() {
  _extends5 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends5.apply(this, arguments);
}
var PendingInvitationSkeleton = ({ message }) => {
  return /* @__PURE__ */ React11.createElement(Loading2, {
    label: message
  });
};
var PendingInvitation = ({ wrapper, createInvitationUrl, onClickRemove }) => {
  const { t } = useTranslation8("appkit");
  const { cancel, status, haltedAt, authCode, invitationCode } = useInvitationStatus(wrapper);
  const handleRemove = useCallback5(() => {
    const id = wrapper.get().invitationId;
    id && onClickRemove(id);
  }, []);
  return /* @__PURE__ */ React11.createElement("div", {
    role: "group",
    className: mx6(defaultGroup({
      elevation: "group"
    }), "mbe-2")
  }, wrapper.get() ? /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(HeadingWithActions, {
    compact: true,
    spacer: null,
    heading: {
      level: 2,
      className: "text-lg font-body flex gap-2 items-center grow-[99] pie-2",
      children: /* @__PURE__ */ React11.createElement(Avatar2, {
        size: 10,
        fallbackValue: wrapper.get().invitationId,
        label: /* @__PURE__ */ React11.createElement(InvitationStatus, _extends5({}, {
          status,
          haltedAt
        }, {
          className: "grow"
        }))
      })
    },
    actions: /* @__PURE__ */ React11.createElement(React11.Fragment, null, status === Invitation2.State.AUTHENTICATING ? /* @__PURE__ */ React11.createElement("p", {
      className: "text-xl text-center text-success-500 dark:text-success-300"
    }, authCode) : /* @__PURE__ */ React11.createElement(CompactQrCode, _extends5({}, {
      copyLabel: t("copy space invite code short label", {
        ns: "appkit"
      }),
      displayQrLabel: t("display space invite qr code label", {
        ns: "appkit"
      }),
      value: createInvitationUrl(invitationCode)
    })), status === Invitation2.State.CANCELLED || status === Invitation2.State.ERROR || status === Invitation2.State.TIMEOUT || status === Invitation2.State.SUCCESS ? /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(Tooltip, {
      content: t("remove label"),
      tooltipLabelsTrigger: true
    }, /* @__PURE__ */ React11.createElement(Button4, {
      className: "flex md:hidden gap-1 items-center",
      onClick: handleRemove
    }, /* @__PURE__ */ React11.createElement(XCircle, {
      className: getSize3(5)
    }))), /* @__PURE__ */ React11.createElement(Button4, {
      className: "hidden md:flex gap-1 items-center",
      onClick: handleRemove
    }, /* @__PURE__ */ React11.createElement(XCircle, {
      className: getSize3(5)
    }), /* @__PURE__ */ React11.createElement("span", null, t("remove label")))) : /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(Tooltip, {
      content: t("cancel label"),
      tooltipLabelsTrigger: true
    }, /* @__PURE__ */ React11.createElement(Button4, {
      className: "flex md:hidden gap-1 items-center",
      onClick: cancel
    }, /* @__PURE__ */ React11.createElement(ProhibitInset, {
      className: getSize3(5)
    }))), /* @__PURE__ */ React11.createElement(Button4, {
      className: "hidden md:flex gap-1 items-center",
      onClick: cancel
    }, /* @__PURE__ */ React11.createElement(ProhibitInset, {
      className: getSize3(5)
    }), /* @__PURE__ */ React11.createElement("span", null, t("cancel label")))))
  })) : /* @__PURE__ */ React11.createElement(PendingInvitationSkeleton, {
    message: t("generic loading label")
  }));
};

// packages/apps/patterns/react-appkit/src/components/InvitationList/InvitationList.tsx
var InvitationList = ({ createInvitationUrl, invitations, onClickRemove }) => {
  const { t } = useTranslation9("appkit");
  const empty = !invitations || invitations.length < 1;
  return /* @__PURE__ */ React12.createElement(Group2, {
    className: "mlb-4",
    label: {
      level: 2,
      children: !empty ? t("invitations label") : t("empty invitations message"),
      className: mx7("text-xl", empty && defaultDisabled)
    },
    elevation: "base"
  }, !empty && invitations.map((wrapper, index) => {
    var _a;
    return /* @__PURE__ */ React12.createElement(PendingInvitation, {
      key: (_a = wrapper.get().invitationId) != null ? _a : index,
      wrapper,
      createInvitationUrl,
      onClickRemove
    });
  }));
};

// packages/apps/patterns/react-appkit/src/components/Join/JoinDialog.tsx
import React15 from "react";
import { Dialog as Dialog2, useTranslation as useTranslation12 } from "@dxos/react-components";

// packages/apps/patterns/react-appkit/src/components/Join/JoinPanel.tsx
import React14, { useCallback as useCallback7, useEffect as useEffect2, useState as useState4 } from "react";
import { Invitation as Invitation3, InvitationEncoder } from "@dxos/client";
import { useInvitationStatus as useInvitationStatus2 } from "@dxos/react-client";
import { useTranslation as useTranslation11 } from "@dxos/react-components";

// packages/apps/patterns/react-appkit/src/components/SingleInputStep/SingleInputStep.tsx
import React13, { useCallback as useCallback6, useMemo as useMemo2 } from "react";
import { Button as Button5, Input as Input2, Loading as Loading3, mx as mx8, useTranslation as useTranslation10 } from "@dxos/react-components";
function _extends6() {
  _extends6 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends6.apply(this, arguments);
}
var SingleInputStep = ({ inputLabel, onChange, pending, onBack, backLabel, onNext, nextLabel, onCancelPending, cancelPendingLabel, loadingLabel, inputPlaceholder, inputProps }) => {
  const { t } = useTranslation10("appkit");
  const onKeyUp = useCallback6((e) => e.key === "Enter" && onNext(), [
    onNext
  ]);
  const inputSlots = useMemo2(() => {
    var _a;
    return {
      ...inputProps == null ? void 0 : inputProps.slots,
      input: {
        onKeyUp,
        autoFocus: true,
        ...(_a = inputProps == null ? void 0 : inputProps.slots) == null ? void 0 : _a.input
      }
    };
  }, [
    onKeyUp,
    inputProps == null ? void 0 : inputProps.slots
  ]);
  return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(Input2, _extends6({
    size: "lg",
    label: t(inputLabel)
  }, inputProps, inputPlaceholder && {
    placeholder: t(inputPlaceholder)
  }, pending && {
    disabled: true
  }, {
    onChange,
    slots: inputSlots
  })), /* @__PURE__ */ React13.createElement("div", {
    role: "none",
    "aria-live": "polite",
    className: "flex gap-4 justify-end items-center"
  }, /* @__PURE__ */ React13.createElement(Button5, _extends6({
    variant: "primary",
    onClick: onNext
  }, pending && {
    disabled: true
  }, {
    className: "order-last"
  }), nextLabel != null ? nextLabel : t("next label")), onBack && /* @__PURE__ */ React13.createElement(Button5, _extends6({
    onClick: onBack
  }, pending && {
    disabled: true
  }), backLabel != null ? backLabel : t("back label")), /* @__PURE__ */ React13.createElement("div", {
    role: "none",
    className: "grow"
  }), /* @__PURE__ */ React13.createElement("div", {
    role: "none",
    className: mx8(!pending && "hidden")
  }, /* @__PURE__ */ React13.createElement(Loading3, {
    label: loadingLabel || t("generic loading label"),
    slots: {
      root: {
        className: "p-0 mis-0"
      }
    }
  })), onCancelPending && /* @__PURE__ */ React13.createElement(Button5, _extends6({
    onClick: onCancelPending
  }, !pending && {
    disabled: true
  }), cancelPendingLabel != null ? cancelPendingLabel : t("cancel label"))));
};

// packages/apps/patterns/react-appkit/src/components/Join/JoinPanel.tsx
function _extends7() {
  _extends7 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends7.apply(this, arguments);
}
var pinLength = 6;
var JoinStep1 = ({ connect, status, cancel, error, parseInvitation = (code) => code, initialInvitationCode, acceptInvitation }) => {
  const { t } = useTranslation11("appkit");
  const [invitationCode, setInvitationCode] = useState4(initialInvitationCode != null ? initialInvitationCode : "");
  const onConnectNext = useCallback7(async () => {
    const invitation = acceptInvitation(InvitationEncoder.decode(parseInvitation(invitationCode)));
    connect(invitation);
  }, [
    invitationCode
  ]);
  useEffect2(() => {
    if (initialInvitationCode) {
      void onConnectNext();
    }
  }, []);
  return /* @__PURE__ */ React14.createElement(SingleInputStep, _extends7({}, {
    pending: status === Invitation3.State.CONNECTING,
    inputLabel: t("invitation code label", {
      ns: "appkit"
    }),
    inputPlaceholder: t("invitation code placeholder", {
      ns: "appkit"
    }),
    inputProps: {
      initialValue: invitationCode,
      slots: {
        input: {
          autoFocus: true,
          className: "text-center"
        }
      },
      ...error && {
        validationMessage: `Untranslated error code: ${error}`,
        validationValence: "error"
      }
    },
    onChange: ({ target: { value } }) => setInvitationCode(value),
    onNext: onConnectNext,
    onCancelPending: cancel
  }));
};
var JoinStep2 = ({ status, error, cancel, authenticate }) => {
  const { t } = useTranslation11("appkit");
  const [invitationSecret, setInvitationSecret] = useState4("");
  const [pending, setPending] = useState4(false);
  const onAuthenticateNext = useCallback7((secret) => {
    setPending(true);
    authenticate(secret).finally(() => setPending(false));
  }, []);
  const onChange = useCallback7(({ target: { value } }) => {
    setInvitationSecret(value);
    value.length === pinLength && onAuthenticateNext(value);
  }, [
    onAuthenticateNext
  ]);
  return /* @__PURE__ */ React14.createElement(SingleInputStep, _extends7({}, {
    pending,
    inputLabel: t("invitation secret label", {
      ns: "appkit"
    }),
    inputProps: {
      size: "pin",
      length: pinLength,
      initialValue: "",
      slots: {
        input: {
          autoFocus: true,
          inputMode: "numeric",
          pattern: "\\d*"
        }
      },
      ...error && {
        validationMessage: `Untranslated error code: ${error}`,
        validationValence: "error"
      }
    },
    onChange,
    onNext: () => onAuthenticateNext(invitationSecret),
    onCancelPending: cancel
  }));
};
var JoinPanel = (props) => {
  const { status, cancel, error, connect, authenticate, result, haltedAt } = useInvitationStatus2();
  useEffect2(() => {
    var _a;
    if (status === Invitation3.State.SUCCESS && result) {
      (_a = props.onJoin) == null ? void 0 : _a.call(props, result);
    }
  }, [
    status,
    result
  ]);
  const cursor = status === Invitation3.State.ERROR || status === Invitation3.State.TIMEOUT || status === Invitation3.State.CANCELLED ? haltedAt : status;
  return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(InvitationStatus, _extends7({}, {
    status,
    haltedAt
  }, {
    className: "mbs-3"
  })), cursor < Invitation3.State.CONNECTED ? /* @__PURE__ */ React14.createElement(JoinStep1, _extends7({}, props, {
    connect,
    status,
    cancel,
    error
  })) : /* @__PURE__ */ React14.createElement(JoinStep2, _extends7({}, props, {
    connect,
    authenticate,
    status,
    cancel,
    error
  })));
};

// packages/apps/patterns/react-appkit/src/components/Join/JoinDialog.tsx
function _extends8() {
  _extends8 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends8.apply(this, arguments);
}
var JoinDialog = ({ dialogProps, ...props }) => {
  const { t } = useTranslation12("appkit");
  return /* @__PURE__ */ React15.createElement(Dialog2, _extends8({
    title: t("join space label")
  }, dialogProps), /* @__PURE__ */ React15.createElement(JoinPanel, _extends8({}, props)));
};

// packages/apps/patterns/react-appkit/src/components/ManageSpacePage/ManageSpacePage.tsx
import { UserPlus } from "@phosphor-icons/react";
import React17, { useCallback as useCallback8, useMemo as useMemo4 } from "react";
import { useNavigate, useParams } from "react-router-dom";
import urlJoin from "url-join";
import { useMembers, useSpace, useSpaceInvitations } from "@dxos/react-client";
import { Button as Button6, getSize as getSize4, useTranslation as useTranslation14 } from "@dxos/react-components";

// packages/apps/patterns/react-appkit/src/hooks/useFileDownload.ts
import { useMemo as useMemo3 } from "react";
var useFileDownload = () => {
  return useMemo3(() => (data, filename) => {
    const url = typeof data === "string" ? data : URL.createObjectURL(data);
    const element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("download", filename);
    element.setAttribute("target", "download");
    element.click();
  }, []);
};

// packages/apps/patterns/react-appkit/src/hooks/useSafeSpaceKey.ts
import { useEffect as useEffect3, useState as useState5 } from "react";
import { PublicKey } from "@dxos/keys";
import { log } from "@dxos/log";
var useSafeSpaceKey = (hex, onFailure) => {
  const [spaceKey, setSpaceKey] = useState5();
  useEffect3(() => {
    if (hex) {
      try {
        setSpaceKey(PublicKey.fromHex(hex));
      } catch (e) {
        log.warn("invalid space key", {
          hex
        }, {
          file: "useSafeSpaceKey.ts",
          line: 23,
          scope: void 0,
          callSite: (f, a) => f(...a)
        });
        onFailure == null ? void 0 : onFailure();
      }
    } else {
      setSpaceKey(void 0);
    }
  }, [
    hex
  ]);
  return spaceKey;
};

// packages/apps/patterns/react-appkit/src/hooks/useTelemetry.ts
import { useEffect as useEffect4 } from "react";
import { useLocation } from "react-router-dom";
import { useClient } from "@dxos/react-client";
import * as Telemetry from "@dxos/telemetry";
var useTelemetry = ({ namespace, router = true }) => {
  const location2 = router ? useLocation() : null;
  const client = useClient();
  useEffect4(() => {
    Telemetry.event({
      identityId: getTelemetryIdentifier(client),
      name: `${namespace}.page.load`,
      properties: {
        ...BASE_TELEMETRY_PROPERTIES,
        href: window.location.href,
        loadDuration: window.performance.timing.loadEventEnd - window.performance.timing.loadEventStart
      }
    });
    return setupTelemetryListeners(namespace, client);
  }, []);
  useEffect4(() => {
    Telemetry.page({
      identityId: getTelemetryIdentifier(client),
      properties: BASE_TELEMETRY_PROPERTIES
    });
  }, [
    location2
  ]);
};

// packages/apps/patterns/react-appkit/src/components/ProfileList/ProfileList.tsx
import React16 from "react";
import { useIdentity } from "@dxos/react-client";
import { useTranslation as useTranslation13, Tag as Tag2, Avatar as Avatar3, defaultDisabled as defaultDisabled2, defaultGroup as defaultGroup2, Group as Group3, mx as mx9 } from "@dxos/react-components";
import { humanize } from "@dxos/util";
var ProfileList = ({ identities }) => {
  const { t } = useTranslation13("appkit");
  const myIdentity = useIdentity();
  const myIdentityHex = myIdentity == null ? void 0 : myIdentity.identityKey.toHex();
  return identities.length > 0 ? /* @__PURE__ */ React16.createElement("ul", {
    className: "flex flex-col gap-2 mlb-4"
  }, identities.map((identity) => {
    var _a, _b;
    const identityHex = identity.identityKey.toHex();
    return /* @__PURE__ */ React16.createElement("li", {
      key: identityHex,
      className: mx9(defaultGroup2({
        elevation: "group",
        spacing: "p-1",
        rounding: "rounded"
      }), "flex gap-2 items-center")
    }, /* @__PURE__ */ React16.createElement(Avatar3, {
      variant: "circle",
      fallbackValue: identityHex,
      label: /* @__PURE__ */ React16.createElement("p", null, (_b = (_a = identity.profile) == null ? void 0 : _a.displayName) != null ? _b : humanize(identityHex), identityHex === myIdentityHex && /* @__PURE__ */ React16.createElement(Tag2, {
        valence: "info",
        className: "mli-2 align-middle"
      }, t("current identity label")))
    }));
  })) : /* @__PURE__ */ React16.createElement(Group3, {
    className: "mlb-4",
    label: {
      level: 2,
      children: t("empty members message"),
      className: mx9("text-xl", defaultDisabled2)
    },
    elevation: "base"
  });
};

// packages/apps/patterns/react-appkit/src/components/ManageSpacePage/ManageSpacePage.tsx
var defaultCreateInvitationUrl = (invitationCode) => {
  const { origin, pathname } = window.location;
  return urlJoin(origin, pathname, `/#?invitation=${invitationCode}`);
};
var ManageSpacePage = ({ createInvitationUrl = defaultCreateInvitationUrl, spacesPath = "/" }) => {
  const { t } = useTranslation14("appkit");
  const navigate = useNavigate();
  const { spaceKey: spaceHex } = useParams();
  const spaceKey = useSafeSpaceKey(spaceHex, () => navigate(spacesPath));
  const space = useSpace(spaceKey);
  const members = useMembers(spaceKey);
  const memberProfiles = useMemo4(() => members.map(({ identity }) => identity).filter((identity) => !!identity), [
    members
  ]);
  const invitations = useSpaceInvitations(space == null ? void 0 : space.key);
  const handleCreateInvitation = useCallback8(() => {
    if (space) {
      space.createInvitation();
    }
  }, [
    space
  ]);
  const handleRemove = useCallback8((id) => space == null ? void 0 : space.removeInvitation(id), [
    space
  ]);
  return /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(HeadingWithActions, {
    heading: {
      level: 2,
      children: t("space members label", {
        ns: "appkit"
      })
    },
    actions: /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(Button6, {
      variant: "primary",
      onClick: handleCreateInvitation,
      className: "flex gap-1 items-center",
      disabled: !space
    }, /* @__PURE__ */ React17.createElement("span", null, t("create invitation label")), /* @__PURE__ */ React17.createElement(UserPlus, {
      className: getSize4(5)
    })))
  }), /* @__PURE__ */ React17.createElement(ProfileList, {
    identities: memberProfiles
  }), /* @__PURE__ */ React17.createElement(InvitationList, {
    invitations,
    createInvitationUrl,
    onClickRemove: handleRemove
  }));
};

// packages/apps/patterns/react-appkit/src/components/Menubar/Menubar.tsx
import * as ToolbarPrimitive from "@radix-ui/react-toolbar";
import throttle from "lodash.throttle";
import React18, { useCallback as useCallback9, useEffect as useEffect5, useMemo as useMemo5, useState as useState6 } from "react";
import { mx as mx10 } from "@dxos/react-components";
var Separator2 = ToolbarPrimitive.Separator;
var Menubar = ({ children }) => {
  const [atTop, setAtTop] = useState6(true);
  const handleScroll = useCallback9(() => {
    var _a, _b;
    const scrollY = (_b = (_a = document.defaultView) == null ? void 0 : _a.scrollY) != null ? _b : 0;
    setAtTop(scrollY < 8);
  }, []);
  const throttledHandleScroll = useMemo5(() => throttle(handleScroll, 100), [
    handleScroll
  ]);
  useEffect5(() => {
    var _a;
    throttledHandleScroll();
    (_a = document.defaultView) == null ? void 0 : _a.addEventListener("scroll", throttledHandleScroll);
    return () => {
      var _a2;
      return (_a2 = document.defaultView) == null ? void 0 : _a2.removeEventListener("scroll", throttledHandleScroll);
    };
  }, [
    throttledHandleScroll
  ]);
  return /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement(ToolbarPrimitive.Root, {
    className: mx10("fixed inset-inline-0 block-start-0 z-[2] transition-[backdrop-filter,background-color]", "flex items-center gap-x-2 gap-y-4 pli-4 bs-16", atTop ? "pointer-events-none" : "backdrop-blur-md bg-white/20 dark:bg-neutral-700/20")
  }, children));
};

// packages/apps/patterns/react-appkit/src/components/Menubar/ProfileMenu.tsx
import React19 from "react";
import { Avatar as Avatar4, Popover } from "@dxos/react-components";
import { humanize as humanize2 } from "@dxos/util";
var ProfileMenu = (props) => {
  var _a, _b;
  const { identity } = props;
  return /* @__PURE__ */ React19.createElement(Popover, {
    openTrigger: /* @__PURE__ */ React19.createElement(Avatar4, {
      size: 10,
      variant: "circle",
      fallbackValue: identity.identityKey.toHex(),
      label: (_b = (_a = identity.profile) == null ? void 0 : _a.displayName) != null ? _b : humanize2(identity.identityKey.toHex())
    }),
    slots: {
      content: {
        collisionPadding: 8,
        sideOffset: 4,
        className: "flex flex-col gap-4 items-center z-[2]"
      },
      trigger: {
        className: "flex justify-self-end pointer-events-auto bg-white dark:bg-neutral-700 p-0.5 rounded-full"
      }
    },
    triggerIsInToolbar: true
  }, props.children);
};

// packages/apps/patterns/react-appkit/src/components/Menubar/SpacesLink.tsx
import { CaretLeft, Planet } from "@phosphor-icons/react";
import React20 from "react";
import { Button as Button7, getSize as getSize5, useTranslation as useTranslation15 } from "@dxos/react-components";
var SpacesLink = ({ onClickGoToSpaces }) => {
  const { t } = useTranslation15("appkit");
  return /* @__PURE__ */ React20.createElement(Tooltip, {
    content: t("back to spaces label"),
    side: "right",
    tooltipLabelsTrigger: true,
    triggerIsInToolbar: true
  }, /* @__PURE__ */ React20.createElement(Button7, {
    onClick: onClickGoToSpaces,
    className: "pointer-events-auto flex gap-1"
  }, /* @__PURE__ */ React20.createElement(CaretLeft, {
    className: getSize5(4)
  }), /* @__PURE__ */ React20.createElement(Planet, {
    className: getSize5(4)
  })));
};

// packages/apps/patterns/react-appkit/src/components/Menubar/SpaceLink.tsx
import { Check } from "@phosphor-icons/react";
import { Button as ToolbarButtonItem2 } from "@radix-ui/react-toolbar";
import React21 from "react";
import { Button as Button8, getSize as getSize6, useTranslation as useTranslation16 } from "@dxos/react-components";
var SpaceLink = ({ onClickGoToSpace }) => {
  const { t } = useTranslation16("appkit");
  return /* @__PURE__ */ React21.createElement(ToolbarButtonItem2, {
    asChild: true
  }, /* @__PURE__ */ React21.createElement(Button8, {
    className: "pointer-events-auto flex gap-1 pli-2",
    onClick: onClickGoToSpace
  }, /* @__PURE__ */ React21.createElement("span", {
    className: "text-xs"
  }, t("go to space label")), /* @__PURE__ */ React21.createElement(Check, {
    className: getSize6(4)
  })));
};

// packages/apps/patterns/react-appkit/src/components/Menubar/SpaceMenu.tsx
import { Gear, UserPlus as UserPlus2, UsersThree } from "@phosphor-icons/react";
import React22 from "react";
import { useMembers as useMembers2 } from "@dxos/react-client";
import { Button as Button9, defaultInlineSeparator, getSize as getSize7, Popover as Popover2, mx as mx11, buttonStyles, useTranslation as useTranslation17 } from "@dxos/react-components";
var SpaceMenu = ({ space, onClickManageSpace }) => {
  const { t } = useTranslation17("appkit");
  const members = useMembers2(space.key);
  return /* @__PURE__ */ React22.createElement(Popover2, {
    openTrigger: /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(UsersThree, {
      className: getSize7(4)
    }), /* @__PURE__ */ React22.createElement("span", {
      className: "leading-none"
    }, members.length), /* @__PURE__ */ React22.createElement("span", {
      role: "none",
      className: mx11(defaultInlineSeparator, "bs-3")
    }), /* @__PURE__ */ React22.createElement(UserPlus2, {
      className: getSize7(4)
    })),
    slots: {
      content: {
        collisionPadding: 8,
        sideOffset: 4,
        className: "flex flex-col gap-4 items-center z-[2]"
      },
      trigger: {
        className: mx11(buttonStyles(), "pointer-events-auto flex items-center gap-1")
      }
    },
    triggerIsInToolbar: true
  }, onClickManageSpace && /* @__PURE__ */ React22.createElement(Button9, {
    className: "flex w-full gap-2",
    onClick: onClickManageSpace
  }, /* @__PURE__ */ React22.createElement(Gear, {
    className: getSize7(5)
  }), /* @__PURE__ */ React22.createElement("span", null, t("manage space label"))));
};

// packages/apps/patterns/react-appkit/src/components/RequireIdentity/RequireIdentity.tsx
import React23, { useEffect as useEffect6 } from "react";
import { Outlet } from "react-router-dom";
import { useIdentity as useIdentity2, useClient as useClient2 } from "@dxos/react-client";
var RequireIdentity = ({ redirect: to }) => {
  const client = useClient2();
  const identity = useIdentity2();
  const remoteSource = new URL(client.config.get("runtime.client.remoteSource") || "https://halo.dxos.org");
  useEffect6(() => {
    if (!identity) {
      const redirect = `#?redirect=${encodeURIComponent(window.location.href)}`;
      window.location.replace(`${to != null ? to : remoteSource.origin}${redirect}`);
    }
  }, []);
  if (!identity) {
    return null;
  }
  return /* @__PURE__ */ React23.createElement(Outlet, null);
};

// packages/apps/patterns/react-appkit/src/components/ServiceWorkerToast/ServiceWorkerToast.tsx
import { Gift } from "@phosphor-icons/react";
import React24 from "react";
import { useTranslation as useTranslation18, Toast, Button as Button10, getSize as getSize8, mx as mx12, useTranslationsContext } from "@dxos/react-components";
function _extends9() {
  _extends9 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends9.apply(this, arguments);
}
var isNeedRefreshToast = (props) => props.variant === "needRefresh";
var ServiceWorkerToast = (props) => {
  const { t } = useTranslation18("appkit");
  const { appNs } = useTranslationsContext();
  const { variant } = props;
  return /* @__PURE__ */ React24.createElement(Toast, _extends9({
    initiallyOpen: true,
    title: variant === "needRefresh" ? /* @__PURE__ */ React24.createElement(React24.Fragment, null, /* @__PURE__ */ React24.createElement(Gift, {
      className: mx12(getSize8(5), "inline mr-1"),
      weight: "duotone"
    }), /* @__PURE__ */ React24.createElement("span", null, t("need refresh label"))) : t("offline ready label", {
      appName: t("current app name", {
        ns: appNs
      })
    })
  }, isNeedRefreshToast(props) && {
    slots: {
      root: {
        duration: 24e4
      }
    },
    description: t("need refresh description"),
    actionTriggers: [
      {
        altText: t("refresh alt"),
        trigger: /* @__PURE__ */ React24.createElement(Button10, {
          variant: "primary",
          onClick: () => props.updateServiceWorker()
        }, t("refresh label"))
      }
    ]
  }, variant === "offlineReady" && {
    closeTrigger: /* @__PURE__ */ React24.createElement(Button10, null, t("confirm label", {
      ns: "appkit"
    }))
  }));
};

// packages/apps/patterns/react-appkit/src/components/ServiceWorkerToast/ServiceWorkerToastContainer.tsx
import React25 from "react";
function _extends10() {
  _extends10 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends10.apply(this, arguments);
}
var ServiceWorkerToastContainer = (props) => {
  const { needRefresh: [needRefresh, _setNeedRefresh], offlineReady: [offlineReady, _setOfflineReady], updateServiceWorker } = props;
  return needRefresh ? /* @__PURE__ */ React25.createElement(ServiceWorkerToast, _extends10({}, {
    variant: "needRefresh",
    updateServiceWorker
  })) : offlineReady ? /* @__PURE__ */ React25.createElement(ServiceWorkerToast, {
    variant: "offlineReady"
  }) : null;
};

// packages/apps/patterns/react-appkit/src/components/SpaceList/SpaceList.tsx
import React26 from "react";
import { Link } from "react-router-dom";
import { Avatar as Avatar5, defaultGroup as defaultGroup3, hover, defaultFocus as defaultFocus2, useTranslation as useTranslation19, defaultDisabled as defaultDisabled3, Group as Group4, Heading as Heading3, mx as mx13 } from "@dxos/react-components";
import { humanize as humanize3 } from "@dxos/util";
var SpaceList = ({ spaces = [] }) => {
  const { t } = useTranslation19("appkit");
  return spaces.length ? /* @__PURE__ */ React26.createElement(React26.Fragment, null, spaces.map((space) => {
    var _a, _b;
    const keyHex = space == null ? void 0 : space.key.toHex();
    const title = (_b = (_a = space == null ? void 0 : space.properties) == null ? void 0 : _a.title) != null ? _b : humanize3(keyHex);
    return /* @__PURE__ */ React26.createElement(Link, {
      to: `/spaces/${keyHex}`,
      role: "group",
      key: keyHex,
      className: mx13(defaultGroup3({
        elevation: "group",
        rounding: "rounded",
        spacing: "p-2"
      }), "flex items-stretch gap-2 mbe-2", hover(), defaultFocus2)
    }, /* @__PURE__ */ React26.createElement(Heading3, {
      level: 2,
      className: "grow flex items-center mbe-0"
    }, /* @__PURE__ */ React26.createElement(Avatar5, {
      size: 12,
      fallbackValue: keyHex,
      label: /* @__PURE__ */ React26.createElement("p", {
        className: "text-lg grow"
      }, title),
      slots: {
        root: {
          className: "flex gap-1 items-center pr-2 rounded"
        }
      }
    })));
  })) : /* @__PURE__ */ React26.createElement(Group4, {
    className: "mlb-4",
    label: {
      level: 2,
      children: t("empty spaces label"),
      className: mx13("text-xl", defaultDisabled3)
    },
    elevation: "base"
  }, /* @__PURE__ */ React26.createElement("p", {
    className: defaultDisabled3
  }, t("empty spaces message")));
};

// packages/apps/patterns/react-appkit/src/components/SpacesPage/SpacesPageComponent.tsx
import { Plus as Plus3, Rocket } from "@phosphor-icons/react";
import React27 from "react";
import { useSearchParams } from "react-router-dom";
import { useClient as useClient3, useSpaces } from "@dxos/react-client";
import { Button as Button11, getSize as getSize9, useTranslation as useTranslation20 } from "@dxos/react-components";
var invitationCodeFromUrl = (url) => {
  try {
    const searchParams = new URLSearchParams(url.substring(url.lastIndexOf("?")));
    const invitation = searchParams.get("invitation");
    return invitation != null ? invitation : url;
  } catch (err) {
    console.error(err);
    return url;
  }
};
var SpacesPageComponent = (props) => {
  const { onSpaceCreated, onSpaceJoined } = props;
  const { t } = useTranslation20("appkit");
  const client = useClient3();
  const spaces = useSpaces();
  const [searchParams] = useSearchParams();
  const invitationParam = searchParams.get("invitation");
  return /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(HeadingWithActions, {
    className: "flex-auto text-center mbe-4",
    actions: /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(JoinDialog, {
      initialInvitationCode: invitationParam != null ? invitationParam : void 0,
      parseInvitation: (invitationCode) => invitationCodeFromUrl(invitationCode),
      onJoin: (result) => onSpaceJoined == null ? void 0 : onSpaceJoined(result),
      acceptInvitation: (invitation) => client.acceptInvitation(invitation),
      dialogProps: {
        defaultOpen: Boolean(invitationParam),
        openTrigger: /* @__PURE__ */ React27.createElement(Button11, {
          className: "grow flex gap-1"
        }, /* @__PURE__ */ React27.createElement(Rocket, {
          className: getSize9(5)
        }), t("join space label", {
          ns: "appkit"
        }))
      }
    }), /* @__PURE__ */ React27.createElement(Button11, {
      variant: "primary",
      onClick: async () => {
        const space = await client.createSpace();
        onSpaceCreated == null ? void 0 : onSpaceCreated(space);
      },
      className: "grow flex gap-1"
    }, /* @__PURE__ */ React27.createElement(Plus3, {
      className: getSize9(5)
    }), t("create space label", {
      ns: "appkit"
    }))),
    heading: {
      children: t("spaces label")
    }
  }), /* @__PURE__ */ React27.createElement(SpaceList, {
    spaces
  }));
};

// packages/apps/patterns/react-appkit/src/components/SpacesPage/SpacesPage.tsx
import { Plus as Plus4, Rocket as Rocket2 } from "@phosphor-icons/react";
import React28, { useCallback as useCallback10 } from "react";
import { generatePath, useNavigate as useNavigate2, useSearchParams as useSearchParams2 } from "react-router-dom";
import { useClient as useClient4, useSpaces as useSpaces2 } from "@dxos/react-client";
import { Button as Button12, getSize as getSize10, useTranslation as useTranslation21 } from "@dxos/react-components";
var invitationCodeFromUrl2 = (text) => {
  try {
    const searchParams = new URLSearchParams(text.substring(text.lastIndexOf("?")));
    const invitation = searchParams.get("invitation");
    return invitation != null ? invitation : text;
  } catch (err) {
    console.error(err);
    return text;
  }
};
var SpacesPage = ({ onSpaceCreate, spacePath = "/spaces/:space" }) => {
  const { t } = useTranslation21("appkit");
  const client = useClient4();
  const spaces = useSpaces2();
  const [searchParams] = useSearchParams2();
  const navigate = useNavigate2();
  const invitationParam = searchParams.get("invitation");
  const acceptInvitation = useCallback10((invitation) => client.acceptInvitation(invitation), [
    client
  ]);
  const handleCreateSpace = useCallback10(async () => {
    const space = await client.createSpace();
    await (onSpaceCreate == null ? void 0 : onSpaceCreate(space));
  }, [
    client
  ]);
  const handleJoin = useCallback10(({ spaceKey }) => navigate(generatePath(spacePath, {
    space: spaceKey.toHex()
  })), [
    spacePath
  ]);
  return /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(HeadingWithActions, {
    className: "flex-auto text-center mbe-4",
    actions: /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(JoinDialog, {
      initialInvitationCode: invitationParam != null ? invitationParam : void 0,
      parseInvitation: (invitationCode) => invitationCodeFromUrl2(invitationCode),
      onJoin: handleJoin,
      acceptInvitation,
      dialogProps: {
        defaultOpen: Boolean(invitationParam),
        openTrigger: /* @__PURE__ */ React28.createElement(Button12, {
          className: "grow flex gap-1"
        }, /* @__PURE__ */ React28.createElement(Rocket2, {
          className: getSize10(5)
        }), t("join space label", {
          ns: "appkit"
        }))
      }
    }), /* @__PURE__ */ React28.createElement(Button12, {
      variant: "primary",
      onClick: handleCreateSpace,
      className: "grow flex gap-1"
    }, /* @__PURE__ */ React28.createElement(Plus4, {
      className: getSize10(5)
    }), t("create space label", {
      ns: "appkit"
    }))),
    heading: {
      children: t("spaces label")
    }
  }), /* @__PURE__ */ React28.createElement(SpaceList, {
    spaces
  }));
};

// packages/apps/patterns/react-appkit/src/components/StatusIndicator/StatusIndicator.tsx
import { WifiHigh, WifiSlash } from "@phosphor-icons/react";
import React29 from "react";
import { ConnectionState } from "@dxos/protocols/proto/dxos/client/services";
import { useClient as useClient5, useNetworkStatus } from "@dxos/react-client";
import { valenceColorText as valenceColorText2, mx as mx14, Button as Button13 } from "@dxos/react-components";
var StatusIndicator = () => {
  const { state } = useNetworkStatus();
  const client = useClient5();
  const handleStateToggle = async () => {
    void (state === ConnectionState.ONLINE ? client.mesh.setConnectionState(ConnectionState.OFFLINE) : client.mesh.setConnectionState(ConnectionState.ONLINE));
  };
  const toggleButton = /* @__PURE__ */ React29.createElement(Button13, {
    onClick: handleStateToggle
  }, state && state === ConnectionState.ONLINE ? /* @__PURE__ */ React29.createElement(WifiHigh, null) : /* @__PURE__ */ React29.createElement(WifiSlash, null));
  const onlineBall = /* @__PURE__ */ React29.createElement("span", {
    className: "flex h-3 w-3"
  }, /* @__PURE__ */ React29.createElement("span", {
    className: "animate-ping absolute inline-flex h-full w-full rounded-full bg-green-600 opacity-75"
  }), /* @__PURE__ */ React29.createElement("span", {
    className: "relative inline-flex rounded-full h-3 w-3 bg-green-700"
  }));
  const offlineBall = /* @__PURE__ */ React29.createElement("span", {
    className: "flex h-3 w-3"
  }, /* @__PURE__ */ React29.createElement("span", {
    className: "relative inline-flex rounded-full h-3 w-3 bg-red-500"
  }));
  return /* @__PURE__ */ React29.createElement("div", {
    role: "none",
    className: mx14("fixed bottom-4 right-4")
  }, /* @__PURE__ */ React29.createElement("div", {
    role: "none",
    className: mx14("fixed bottom-4 right-4", valenceColorText2(state && state === ConnectionState.ONLINE ? "success" : "error"))
  }, /* @__PURE__ */ React29.createElement(Tooltip, {
    content: toggleButton
  }, state && state === ConnectionState.ONLINE ? onlineBall : offlineBall)));
};

// packages/apps/patterns/react-appkit/src/components/Tile/Tile.tsx
import React30 from "react";
import { Group as Group5 } from "@dxos/react-components";

// packages/apps/patterns/react-appkit/src/proto/gen/tasks.ts
import * as dxos_echo_schema from "@dxos/echo-schema";
var schemaJson = '{"nested":{"dxos":{"nested":{"tasks":{"nested":{"TaskList":{"options":{"(object)":true},"oneofs":{"_title":{"oneof":["title"]},"_description":{"oneof":["description"]}},"fields":{"title":{"type":"string","id":1,"options":{"proto3_optional":true}},"description":{"type":"string","id":2,"options":{"proto3_optional":true}},"tasks":{"rule":"repeated","type":"Task","id":3}}},"Task":{"options":{"(object)":true},"oneofs":{"_description":{"oneof":["description"]},"_completed":{"oneof":["completed"]},"_due":{"oneof":["due"]}},"fields":{"title":{"type":"string","id":1},"description":{"type":"string","id":2,"options":{"proto3_optional":true}},"completed":{"type":"bool","id":3,"options":{"proto3_optional":true}},"due":{"type":"string","id":4,"options":{"proto3_optional":true}}}}}}}}}}';
var schema = dxos_echo_schema.EchoSchema.fromJson(schemaJson);
var _TaskList = class extends dxos_echo_schema.TypedObject {
  static filter(opts) {
    return _TaskList.type.createFilter(opts);
  }
  constructor(opts) {
    super({
      ...opts
    }, _TaskList.type);
  }
};
var TaskList = _TaskList;
TaskList.type = schema.getType("dxos.tasks.TaskList");
schema.registerPrototype(TaskList);
var _Task = class extends dxos_echo_schema.TypedObject {
  static filter(opts) {
    return _Task.type.createFilter(opts);
  }
  constructor(opts) {
    super({
      ...opts
    }, _Task.type);
  }
};
var Task = _Task;
Task.type = schema.getType("dxos.tasks.Task");
schema.registerPrototype(Task);

// packages/apps/patterns/react-appkit/src/components/Tile/Tile.tsx
var BaseTile = Group5;
var DefaultTile = {
  canRender: (_data) => true,
  render: ({ data }) => /* @__PURE__ */ React30.createElement(BaseTile, {
    label: {
      children: data ? data.title : "Unknown object"
    }
  }, /* @__PURE__ */ React30.createElement("pre", null, JSON.stringify(data, null, 2)))
};
var TaskListTile = {
  // TODO(wittjosiah): Ideally the type string would be exported from the schema as a constant.
  // TODO(wittjosiah): `data instanceof TaskList` should work
  canRender: (data) => data.__typename === TaskList.type.name,
  render: ({ data }) => /* @__PURE__ */ React30.createElement(BaseTile, {
    label: {
      children: data.title
    }
  }, /* @__PURE__ */ React30.createElement("ul", null, data.tasks.map((task) => /* @__PURE__ */ React30.createElement("li", {
    key: task.id
  }, task.title))))
};
var TaskTile = {
  canRender: (data) => data.__typename === Task.type.name,
  render: ({ data }) => /* @__PURE__ */ React30.createElement(BaseTile, {
    label: {
      children: /* @__PURE__ */ React30.createElement(React30.Fragment, null, /* @__PURE__ */ React30.createElement("input", {
        type: "checkbox",
        checked: data.completed,
        className: "mr-2",
        disabled: true
      }), data.title)
    }
  }, data.description)
};
var ALL_CARDS = [
  TaskListTile,
  TaskTile,
  // NOTE: Must be last.
  DefaultTile
];
var GenericTile = ({ data }) => {
  const card = ALL_CARDS.find((card2) => card2.canRender(data));
  return card.render({
    data
  });
};

// packages/apps/patterns/react-appkit/src/translations/en-US.ts
var en_US_exports = {};
__export(en_US_exports, {
  appkit: () => appkit
});
var appkit = {
  "current app name": "This app",
  "loading translations": "Loading translations\u2026",
  "generic loading label": "Loading\u2026",
  "auth choices label": "Choose an identity",
  "create identity label": "Create an identity",
  "create identity description": "Create a new identity.",
  "recover identity label": "Use a seed phrase",
  "recover identity description": "Enter your seed phrase to log in manually.",
  "join identity label": "Use an authed device",
  "join identity description": "Add this device to an identity you\u2019re already logged into on another device.",
  "join space label": "Join a space",
  "create space label": "Create a space",
  "share space label": "Share space",
  "displayName label": "Display name",
  "displayName placeholder": "Enter your preferred display name here",
  "invitation code label": "Invitation code or URL",
  "invitation code placeholder": "Paste the invitation code or URL here",
  "invitation secret label": "Authentication code",
  "seed phrase label": "Seed phrase (space separated)",
  "seed phrase placeholder": "Enter your seed phrase here",
  "back label": "Back",
  "next label": "Next",
  "redeem invitation label": "Redeem invitation",
  "cancel label": "Cancel",
  "remove label": "Remove",
  "confirm label": "Okay",
  "validate seed phrase label": "Validate seed phrase",
  "fatal error label": "Runtime error",
  "fatal error message": "Something went wrong that requires the app to be reloaded.",
  "caught error message": "Something went wrong; check the console for details.",
  "copy error label": "Copy this error",
  "reload page label": "Reload",
  "generic copy label": "Copy",
  "generic help label": "Help",
  "manage profile label": "Manage identity",
  "manage space label": "Manage space",
  "copy halo invite code label": "Scan to authenticate a device, click to copy URL",
  "copy space invite code label": "Scan to join, click to copy URL",
  "copy space invite code short label": "Copy invitation",
  "display space invite qr code label": "Show QR",
  "add contact label": "Add a contact",
  "open apps directory label": "Open apps directory",
  "pending label": "Pending",
  "more options label": "More options",
  "empty space message": "Nobody else is in this space\u2026 yet.",
  "space members label": "Members",
  "go to space label": "Done",
  "halo logo alt": "Halo logo",
  "close label": "Close",
  "error status label": "Error accepting invitation",
  "cancelled status label": "Cancelled",
  "timeout status label": "Timed out",
  "init status label": "Enter an invitation code to start",
  "connecting status label": "Connecting\u2026",
  "connected status label": "Enter the PIN for this invitation to continue",
  "authenticating status label": "Checking PIN\u2026",
  "success status label": "Successfully accepted invitation",
  "back to spaces label": "Back to spaces",
  "list title label": "List title",
  "list title placeholder": "Untitled list",
  "list description label": "List description",
  "list description placeholder": "Add an optional description",
  "list item title label": "List item title",
  "list item title placeholder": "Type here",
  "list item description label": "List item description",
  "list item description placeholder": "Add an optional description",
  "move list item up label": "Move list item up",
  "move list item down label": "Move list item down",
  "delete list item label": "Remove list item",
  "add list item label": "Add list item",
  "need refresh label": "Refresh now to get app updates",
  "need refresh description": "You\u2019ll need these updates to continue without interruption.",
  "refresh label": "Refresh",
  "refresh alt": "Click your browser\u2019s refresh button or use the refresh keyboard shortcut.",
  "offline ready label": "{{appName}} is ready to use offline.",
  "spaces label": "Spaces",
  "empty invitations message": "No pending invitations",
  "invitations label": "Invitations",
  "create invitation label": "Invite",
  "current identity label": "You",
  "empty members message": "No members in this space",
  "composer placeholder": "Enter text\u2026",
  "heartbeat stalled": "Heartbeat stalled",
  "empty spaces label": "No spaces here",
  "empty spaces message": "Why not try creating or joining one?",
  "current device label": "This device",
  "resume heading label": "Resume session",
  "resume description label": "Only one tab can be active at a time",
  "resume label": "Resume",
  "list item input label": "List item title",
  "list item input placeholder": "Enter text\u2026",
  "new list item input label": "New list item title",
  "new list item input placeholder": "Enter text\u2026"
};

// packages/apps/patterns/react-appkit/src/translations/index.ts
var appkitTranslations = {
  "en-US": en_US_exports
};
export {
  ALL_CARDS,
  AuthChoices,
  BaseTile,
  ClientFallback,
  DefaultTile,
  DeviceList,
  EditableList,
  EditableListItem,
  ErrorContext,
  ErrorProvider,
  Fallback,
  FatalError,
  GenericFallback,
  GenericTile,
  HeadingWithActions,
  InvitationList,
  JoinDialog,
  JoinPanel,
  ManageSpacePage,
  Menubar,
  ProfileList,
  ProfileMenu,
  RequireIdentity,
  Separator2 as Separator,
  ServiceWorkerToast,
  ServiceWorkerToastContainer,
  SingleInputStep,
  SpaceLink,
  SpaceList,
  SpaceMenu,
  SpacesLink,
  SpacesPage,
  SpacesPageComponent,
  StatusIndicator,
  TaskListTile,
  TaskTile,
  Tooltip,
  appkitTranslations,
  useEditableListKeyboardInteractions,
  useErrors,
  useFileDownload,
  useSafeSpaceKey,
  useTelemetry
};
//# sourceMappingURL=index.mjs.map
